import CarouselAbstract, { CarouselOptions } from './CarouselAbstract';

/*
Useage: Example for use with multiple carousel on one page

const carouselElems = document.querySelectorAll('.__entry .carousel');
if (let i = 0, l = entryCarouselEls.length; i < l; i++) {
	new Carousel({
		analyticsCategory: 'Carousel',
		carouselClass: 'carousel',
		carouselEl: carouselElems[i] as HTMLElement,
		duration: 7500,
		allowIndicatorClick: true,
		autoAdvance: true
	});
}

*/
export default class Carousel extends CarouselAbstract {
	/**
	 * each derived class that contains a constructor function must call
	 * super() which will execute the constructor of the base class
	 */
	constructor(options: CarouselOptions) {
		super(options);

		this.buildSlides();
		this.buildIndicators();
		this.buildControls(this.carouselEl.querySelector('.carousel__inner') as HTMLElement);
		this.buildControlsAdditional(this.carouselEl as HTMLElement);
		this.activateIndex(this.startingIndex);
		this.initAutoAdvance();
	}
}
